<section class="mainTopBanner">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper section-pd ">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">AI 智慧寫作助手</h1>
                        <h2 class="text-white">靈感不打烊，<br/>寫作不卡關</h2>
                        <p class="text-white">從靈光乍現到句句精鍊，Trinka 隨時待命。想要從頭開始、潤飾想法，還是銜接上一段落，Trinka AI 都能幫你輕鬆搞定。</p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" class="white-btn" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="/assets/images/features/ai-studio/keep-writing.png">
                            <source src="/assets/images/features/ai-studio/ai-ask.mp4#t=0.1" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                        <span class="shape"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="apps-library-banner">
        <div class="app-inner">
        </div>
    </div>
</section>

<section class="section-pd bg-light">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-9">
                <div class="trinka-title mb-0 text-center">
                    <h2>什麼是 Trinka 的 AI 智慧寫作？</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">透過輸入 /ask 指令，即可啟用 Trinka 的 AI 智慧寫作功能，將生成式 AI 無縫整合進你的寫作流程中。這項功能能根據上下文，自動生成內容、優化語句，讓你寫得更快、更好，大幅提升寫作體驗與效率。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>為什麼選擇 AI 智慧寫作？</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <div class="features_cards_icon">
                        <img src="/assets/images/features/ai-studio/icons/writer-block.svg" class="h-auto" width="48" height="49" alt="Avoid Writer's Block" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>擺脫寫作卡關</h3>
                        <p>卡在一個句子？寫到一半靈感斷線？讓 Trinka 幫你接著寫，依照上下文延伸內容，輕鬆突破寫作瓶頸。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <div class="features_cards_icon">
                        <img src="/assets/images/features/ai-studio/icons/word-conversion.svg" class="h-auto" width="48" height="49" alt="Convert Ideas into Words" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>靈感轉化為文字</h3>
                        <p>不知道該從哪裡開始？只要一句話，Trinka 就能幫你從零開始寫作，把腦海中的想法變成高品質、條理清晰的內容。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <div class="features_cards_icon">
                        <img src="/assets/images/features/ai-studio/icons/content-quality.svg" class="h-auto" width="48" height="49" alt="content quality" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>提升內容品質</h3>
                        <p>讓 Trinka 幫你潤飾語句，使文章更流暢、清晰，並自動調整語氣與風格，確保內容更貼近你的目標讀者。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0">
    <div class="trinka_container container">
        <div class="row match-box">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka 的 AI 智慧寫作能為你做到什麼？</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
            <div class="col-lg-6 dflex">
                <div class="c-card key-features-left">
                    <div id="accordion_free" class="accordion">
                        <div class="card" [ngClass]="aiShowTab == 1 ? 'active' : ' '">
                            <div class="card-header">
                                <a class="card-link" (click)="assistedWriting(1)" data-toggle="collapse" href="#freecollapseOne">
                                    <span><img src="/assets/images/features/ai-studio/icons/icon1.svg" width="32" height="32" alt="contextual writing" /></span>
                                    語境延伸寫作
                                </a>
                            </div>
                            <div id="freecollapseOne" class="collapse show" data-parent="#accordion_free">
                                <div class="card-body">
                                    <p>當你選擇「Keep Writing」，Trinka 會根據前後文自動生成內容，協助你順利完成段落與段落間的銜接。</p>
                                </div>
                            </div>
                        </div>
                      
                        <div class="card" [ngClass]="aiShowTab == 2 ? 'active' : ' '">
                            <div class="card-header">
                                <a class="collapsed card-link" (click)="assistedWriting(2)" data-toggle="collapse" href="#freecollapseTwo">
                                    <span><img src="/assets/images/features/ai-studio/icons/icon2.svg" width="32" height="32" alt="scratch writing" /></span>
                                    從零開始寫作
                                </a>
                            </div>
                            <div id="freecollapseTwo" class="collapse" data-parent="#accordion_free">
                                <div class="card-body">
                                    <p>還不知道怎麼開頭？只要選擇「Write a Paragraph」或「Create an Outline」，Trinka 就能帶你順利起步。</p>
                                </div>
                            </div>
                        </div>
                      
                        <div class="card" [ngClass]="aiShowTab == 3 ? 'active' : ' '">
                            <div class="card-header">
                                <a class="collapsed card-link" (click)="assistedWriting(3)" data-toggle="collapse" href="#freecollapseThree">
                                    <span><img src="/assets/images/features/ai-studio/icons/icon3.svg" width="32" height="32" alt="rewrite" /></span>
                                    內容重寫
                                </a>
                            </div>
                            <div id="freecollapseThree" class="collapse" data-parent="#accordion_free">
                                <div class="card-body">
                                    <p>想讓句子更流暢、更有力？請 Trinka 幫你潤飾、簡化或改寫內容，打造更具影響力的表達方式。</p>
                                </div>
                            </div>
                        </div>

                        <div class="card" [ngClass]="aiShowTab == 4 ? 'active' : ' '">
                            <div class="card-header">
                                <a class="collapsed card-link" (click)="assistedWriting(4)" data-toggle="collapse" href="#freecollapseFour">
                                    <span><img src="/assets/images/features/ai-studio/icons/icon4.svg" width="32" height="32" alt="rewrite" /></span>
                                    論點分析
                                </a>
                            </div>
                            <div id="freecollapseFour" class="collapse" data-parent="#accordion_free">
                                <div class="card-body">
                                    <p>輸入想法，Trinka 將協助你強化論點、識別潛在假設，甚至提供深入的評論，讓你的寫作更具邏輯與說服力。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 dflex">
                <div class="c-card key-features-right">
                    <div class="image" [ngClass]="aiShowTab == 1 ? 'show' : ''">
                        <img src="/assets/images/features/ai-studio/keep-writing.png" width="960" height="800" alt="keep writing" />
                    </div>
                    <div class="image" [ngClass]="aiShowTab == 2 ? 'show' : ''">
                        <img src="/assets/images/features/ai-studio/start-writing.png" width="960" height="800" alt="start writing" />
                    </div>
                    <div class="image" [ngClass]="aiShowTab == 3 ? 'show' : ''">
                        <img src="/assets/images/features/ai-studio/rewrite.png" width="960" height="800" alt="rewrite" />
                    </div>
                    <div class="image" [ngClass]="aiShowTab == 4 ? 'show' : ''">
                        <img src="/assets/images/features/ai-studio/argument-analyzer.png" width="960" height="800" alt="analyzer" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2" #viewVideo>
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="/assets/images/features/ai-studio/ask-trinka-thumbnail.webp" width="800" height="450" alt="ask trinka thumbnail" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <ol class="ai-list">
                            <li>在編輯器中開啟你的檔案</li>
                            <li>輸入「/ask」或選取句子，打開提示選單</li>
                            <li>從內建提示中選擇，或自行輸入自訂指令</li>
                        </ol>
                        <p>還有其他問題嗎？歡迎瀏覽我們的常見問答</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-aisuitable-for></app-aisuitable-for>

<app-security-section></app-security-section>

<section class="custom-ai-gradient-light section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center mb-40">
                    <h2 class="mb-4">
                        快速完成草稿，更有效掌握投稿截止時間。
                    </h2>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" class="filled-btn" target="_blank">開始使用</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        什麼是 AI 智慧寫作？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>AI 智慧寫作是利用人工智慧技術協助產生、修飾與提升文字內容。它會根據上下文即時提供建議、修正與內容生成，讓寫作更快速、更有效率。Trinka 的 AI 智慧寫作功能，能幫助你自動生成文字、擴展想法，並優化文章結構與文法，確保內容清晰流暢。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        如何使用 Trinka 的 AI 智慧寫作功能？
                                    </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 的 AI 智慧寫作是一套生成式 AI 工具，完美整合進你的寫作流程。只要輸入 /ask 指令，就能讓 Trinka 根據上下文產生合適的文字，無論是從零開始、發展想法，或是繼續先前未完成的段落。此外，你也可以選取任意文字，點擊 AI 火花圖示，選擇多種內建選項來輔助寫作。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Trinka 的 AI 智慧寫作能創造什麼內容？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 可以幫你激發靈感、建立大綱、撰寫段落、提出評論，輕鬆完成部落格文章與研究草稿。無論是文章、論點分析、評論、部落格文案或說明文字，都能在幾秒鐘內產出可直接審閱的 AI 內容。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        誰可以使用 Trinka 的生成式 AI 寫作功能？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 的 AI 寫作功能適用於所有方案用戶。基礎方案有每月使用次數限制，而高級 Plus 方案則提供更高使用量。更多方案細節，歡迎參考我們的【價格方案】頁面。</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        AI 智慧寫作如何幫助我克服寫作障礙？
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>當你卡在句子或段落，不知道怎麼接下去時，使用 /ask 指令即可請 Trinka 幫你生成相關內容，順利突破寫作瓶頸，保持創作流暢。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        Trinka 如何確保產出的內容與上下文相關？
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka AI 會分析你現有的文字與輸入的提示，生成符合主題與語氣的內容，確保文章前後一致、內容貼切。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        使用 Trinka AI 智慧寫作時，我的資料安全嗎？
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 非常重視資料隱私與安全，所有資料均加密處理，且不會與第三方分享。Trinka 採用自建大型語言模型（LLMs），確保你的私密資料不外流。高級方案與敏感資料方案更提供即時刪除功能，讓你用得更安心。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/2OslhGSAxBk?si=4JiEmLLExeeWoc31"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>